import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getHorariosEntregaMRWByUbicacionId,
  updateHorarioEntregaMRW,
  insertHorarioEntregaMRW,
  deleteHorarioEntregaMRW,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_HORARIOS_ENTREGA_MRW_BY_UBICACION_ID(action) {
  try {
    const horariosEntregaMRWData = yield call(getHorariosEntregaMRWByUbicacionId, action.payload)
    if (horariosEntregaMRWData.ok) {
      yield put({
        type: actions.HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_SUCCEEDED,
        payload: horariosEntregaMRWData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar horarios entrega MRW')
      put({
        type: actions.HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_HORARIO_ENTREGA_MRW(action) {
  try {
    const horarioEntregaMRWObj = yield call(insertHorarioEntregaMRW, action.payload)
    if (horarioEntregaMRWObj.ok) {
      putMessage(messageType.SUCCESS, 'Horario Entrega MRW creado correctamente')
      yield put({
        type: actions.HORARIO_ENTREGA_MRW_INSERT_SUCCEEDED,
        payload: horarioEntregaMRWObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Horario Entrega MRW')
      yield put({
        type: actions.HORARIO_ENTREGA_MRW_INSERT_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Horario Entrega MRW')
    yield all([
      put({
        type: actions.HORARIO_ENTREGA_MRW_INSERT_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_HORARIO_ENTREGA_MRW(action) {
  try {
    const horarioEntregaMRWObj = yield call(updateHorarioEntregaMRW, action.payload)
    if (horarioEntregaMRWObj.ok) {
      putMessage(messageType.SUCCESS, 'Horario Entrega MRW modificado correctamente')
      yield put({
        type: actions.HORARIO_ENTREGA_MRW_UPDATE_SUCCEEDED,
        payload: horarioEntregaMRWObj.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Horario Entrega MRW')
      yield put({
        type: actions.HORARIO_ENTREGA_MRW_UPDATE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Horario Entrega MRW')
    yield all([
      put({
        type: actions.HORARIO_ENTREGA_MRW_UPDATE_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_HORARIO_ENTREGA_MRW(action) {
  try {
    const horarioEntregaMRWResult = yield call(deleteHorarioEntregaMRW, action.payload)
    if (horarioEntregaMRWResult.ok) {
      putMessage(messageType.SUCCESS, 'Horario Entrega MRW eliminado correctamente')
      yield put({
        type: actions.HORARIO_ENTREGA_MRW_DELETE_SUCCEEDED,
        payload: action.payload,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Horario Entrega MRW')
      yield put({
        type: actions.HORARIO_ENTREGA_MRW_DELETE_FILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Horario Entrega MRW')
    yield all([
      put({
        type: actions.HORARIO_ENTREGA_MRW_DELETE_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(
      actions.HORARIOS_ENTREGA_MRW_BY_UBICACION_ID_LOAD_REQUESTED,
      GET_HORARIOS_ENTREGA_MRW_BY_UBICACION_ID,
    ),
    takeEvery(actions.HORARIO_ENTREGA_MRW_INSERT_REQUESTED, INSERT_HORARIO_ENTREGA_MRW),
    takeEvery(actions.HORARIO_ENTREGA_MRW_UPDATE_REQUESTED, UPDATE_HORARIO_ENTREGA_MRW),
    takeEvery(actions.HORARIO_ENTREGA_MRW_DELETE_REQUESTED, DELETE_HORARIO_ENTREGA_MRW),
  ])
}
